import React, { useRef, useState } from 'react'
import { useFrame } from 'react-three-fiber'
import { MeshWobbleMaterial, RoundedBox } from '@react-three/drei'
import gsap from 'gsap'

const BoxShape = ({ position, color, args, speed, factor, cover }) => {
  const [expand, setExpand] = useState(false)

  const props = {
    scale: expand ? [2.5, 2.5, 2.5] : [2, 2, 2],
  }

  const boxRef = useRef(null)
  useFrame(() => {
    boxRef.current.rotation.y += 0.004
    boxRef.current.rotation.x += 0.004
    boxRef.current.rotation.z += 0.004
  })

  const expandFunc = e => {
    let p = boxRef.current.position
    setExpand(!expand)
    gsap.to(p, {
      duration: 2.5,
      ease: 'power4.out',
      z: p.z - 2,
    })
  }

  return (
    <RoundedBox
      ref={boxRef}
      args={props?.scale}
      castShadow
      radius={0.05}
      smoothness={4}
      position={position}
      onClick={e => expandFunc(e)}
    >
      <boxGeometry attach='geometry' />
      <MeshWobbleMaterial
        map={cover?.bashar}
        attach='material'
        factor={factor}
        speed={speed}
      />
    </RoundedBox>
  )
}

export default BoxShape
